import { component, fileConfig, mergeConfig } from '@salutejs/plasma-new-hope/css';

import { config } from './File.config';

const mergedConfig = mergeConfig(fileConfig, config);

export const File = component(mergedConfig);
